import type { NodeCategory } from '@/domain/funnel/node-system';
import type { PresentationGraphInput } from './graph-input';

/** SPEC-011 §51-55/plan §26 — pure category-based stage filtering; never mutates the graph. */
export interface StageFocusResult {
  focusedNodeIds: Set<string>;
  relevantEdgeIds: Set<string>;
}

export function getStageFocus(
  graph: PresentationGraphInput,
  category: NodeCategory | string,
): StageFocusResult {
  const focusedNodeIds = new Set(
    graph.nodes.filter((node) => node.category === category).map((node) => node.id),
  );
  const relevantEdgeIds = new Set(
    graph.edges
      .filter((edge) => focusedNodeIds.has(edge.source) || focusedNodeIds.has(edge.target))
      .map((edge) => edge.id),
  );
  return { focusedNodeIds, relevantEdgeIds };
}
